import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useDrawerContext } from 'context/Drawer/DrawerContext'
import useSession from 'hooks/useSession'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'

export const renderManagementOpinions = (
	managementOpinions,
	i18n,
	openDrawer
) => {
	return managementOpinions.map((managementOpinion, index) => {
		return (
			<div key={index} className={styles['management-container']}>
				<HStack
					className={styles['management-entry']}
					columns={['20px', 4, 1]}
					gap='xsmall'
					align='center'
				>
					<div className={styles['management-icon-container']}>
						<Icon
							className={styles['management-icon']}
							width='18px'
							height='18px'
							name={'supervised-user'}
						/>
					</div>
					<div>
						<small>
							<Tooltip
								text={
									managementOpinion.submittedMedicalRequest ||
									''
								}
							>
								<strong>
									{managementOpinion.submittedMedicalRequest}
								</strong>
							</Tooltip>
						</small>
						<div className={styles['management-status-container']}>
							<Tooltip
								text={
									managementOpinion.creationUser?.name || ''
								}
							>
								<small
									className={`${styles['assigned-to']} ${
										styles[
											managementOpinion.assignedToMe
												? 'my-task'
												: ''
										]
									}`}
								>
									{managementOpinion.assignedTo}
								</small>
							</Tooltip>
							<small className={styles['management-date']}>
								{managementOpinion.creationDate?.dateTimeFormat}
							</small>
						</div>
					</div>
					<ActionButton
						secondary
						onClick={() => {
							openDrawer(
								'ManagementOpinionDrawer',
								managementOpinion
							)
						}}
					>
						<small>
							<strong>{i18n`See`}</strong>
						</small>
					</ActionButton>
				</HStack>
			</div>
		)
	})
}

export const mapUserWithOpinion = (managementOpinions, i18n, sessionUser) => {
	return (managementOpinions || []).map((managementOpinion) => {
		return {
			...managementOpinion,
			assignedTo:
				managementOpinion.creationUser?.id === sessionUser.username
					? i18n`Mine`
					: managementOpinion.creationUser?.id === 'tanque'
					? i18n`Pool`
					: managementOpinion.creationUser?.initials ||
					  managementOpinion.creationUser?.id,
			assignedToMe:
				managementOpinion.creationUser?.id === sessionUser.username,
		}
	})
}

const ManagementOpinionWidget = (props) => {
	const { data } = props
	const { managementOpinions } = data
	const { i18n } = useGlobal()
	const { openDrawer } = useDrawerContext()
	const { user: sessionUser } = useSession()

	const submittedManagementOpinion = managementOpinions?.filter(
		({ isMedicalOpinionResolved }) => isMedicalOpinionResolved
	)

	const mappedManagementOpinion = mapUserWithOpinion(
		submittedManagementOpinion,
		i18n,
		sessionUser
	)

	return mappedManagementOpinion && mappedManagementOpinion.length ? (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='supervised-user'
			title={i18n`Management Opinions`}
			collapsedLabel={mappedManagementOpinion.length}
			expanded={true}
			expandable={true}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{renderManagementOpinions(
				mappedManagementOpinion || [],
				i18n,
				openDrawer
			)}
		</ExpandableWidget>
	) : null
}

export default ManagementOpinionWidget
